import React from 'react';
import { LoaderComponent } from './style';
import Loader from '.';

const TableLoader = () => {
  return (
    <LoaderComponent className='tableLoader'>
      <Loader />
    </LoaderComponent>
  );
};

export default TableLoader;
